import { iso } from 'newtype-ts';
import { PositiveInteger } from 'newtype-ts/es6/PositiveInteger';

export {
  alt,
  applicative as AP,
  apply,
  array as A,
  boolean as B,
  either as E,
  function as F,
  io,
  option as O,
  ord,
  ordering,
  reader as R,
  readonlyArray as RA,
  readonlyMap as RM,
  readonlyNonEmptyArray as RNEA,
  readonlyRecord as RR,
  readonlySet as RS,
  readonlyTuple as RT,
  record,
  semigroup as S,
  set,
  taskEither as TE,
  taskThese as TT,
} from 'fp-ts';
export { Do } from 'fp-ts-contrib';

export const isoPositiveInteger = iso<PositiveInteger>();
